import { useState, useEffect } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Routes, Route} from 'react-router-dom';
import NewScrapEvaluation from './NewScrapEvaluation';
import ConfirmMutilation from './ConfirmMutilation';
import NewMarkingApprovalForm from './NewMarkingApprovalForm';
import UpdateExistingMarkingRequest from './UpdateExistingMarkingRequest';
import PictureMarkingApprovalRequest from './PictureMarkingApprovalRequest';
import NewFinishedPartRequstForm from './NewFinishedPartRequstForm';
import NewRawMaterialsRequstForm from './NewRawMaterialsRequstForm';
import Home from './Home';
import { AuthProvider } from 'oidc-react';


function App() { 

  const [configJsonFileApp, setConfigJsonFileApp] =useState();

  useEffect(()=>{
    const fetchData = async()=>{
      try{
        const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
        const data= await response.json();
        setConfigJsonFileApp(data);
        console.log("Json file read from the Public folder completed in App component:");        
      }catch(error){
        console.error('Error fetching Config JSON file data:',error);
      }
    }
    fetchData();
  },[]);
  
  if(!configJsonFileApp){
return <div>Loading...</div>;
  }

  return (
  <>  
  <AuthProvider
  authority= {configJsonFileApp.Authority}
  clientId={configJsonFileApp.ClientId}
  redirectUri={configJsonFileApp.RedirectUri}  
  responseType={configJsonFileApp.ResponseType}
  scope= {configJsonFileApp.Scope}
  >
  <Routes>           
         <Route path="/" element={<Home />} />
         <Route path="/NewScrapEvaluation" element={<NewScrapEvaluation />} /> 
          <Route path="/ConfirmMutilation" element={<ConfirmMutilation />} /> 
          <Route path="/NewMarkingApprovalForm" element={<NewMarkingApprovalForm />} /> 
          <Route path="/UpdateExistingMarkingRequest" element={<UpdateExistingMarkingRequest />} />  
          <Route path="/PictureMarkingApprovalRequest" element={<PictureMarkingApprovalRequest />} /> 
          <Route path="/NewFinishedPartRequstForm" element={<NewFinishedPartRequstForm />} />     
          <Route path="/NewRawMaterialsRequstForm" element={<NewRawMaterialsRequstForm />} />
  </Routes>
  </AuthProvider>
  </>
  )
}

export default App;
